import React from 'react';
import { RadioGroup } from 'components/UIComponents/FormStyles'; 
import Label from './Label';
import styled from 'styled-components'
import { COLORS } from 'theme'
import { Radio } from 'antd';
import LabelInput from 'components/Form/LabelInput'
const StyledDiv = styled.div`
  ${props => props.width && `width: ${props.width};`}
  ${props => props.minWidth && `min-width: ${props.minWidth};`}
  .ant-radio-wrapper-checked {
    border-color: ${COLORS.PRIMARY};
  }
   flex: 1;          
min-width: 25%;
   
`
const Wrapper = styled.div`
  margin-bottom: 1em;
  width: 100%;
`;


const RadioWrapper = styled.div`
  width: 100%;
  min-width: ${props => props.minWidth || '180px'};
  flex: 1;
`;
const StyledRadio = styled(Radio)`
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #e6e7ea;
  border-radius: 10px;
  font-weight: 600;
  font-size: 16px;
  background-color: ${({ isBgWhite }) => (isBgWhite ? 'white' : 'transparent')};
  color: ${COLORS.HEADING};
  word-break: break-word;
  white-space: normal;

  .ant-radio-inner {
    background-color: transparent;
  }

  .ant-radio-input:focus + .ant-radio-inner {
    box-shadow: none !important;
  }

  .ant-radio-checked .ant-radio-inner::after {
    transform: scale(0.75);
  }
`;
const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(${props => props.minWidth || '180px'}, 1fr));
  gap: 16px;
  width: 100%;
`;


const RadioGroupField = ({
  label,
  name,
  options,
  value,
  onChange,
  error,
  subLabel,
  width,
  isBgWhite = true,
  columns,
  ...rest
}) => (
  <Wrapper >
    {label && <LabelInput>{label}</LabelInput>}
    <RadioGroup name={name} value={value} onChange={e => onChange(e.target.value)}>
      <StyledGrid minWidth={width}>
        {options.map((item, idx) => (
          <RadioWrapper minWidth={width} key={idx + '-' + item.value}>
            <StyledRadio value={item.value} style={{ border: '1px solid #E6E7EA' }} isBgWhite={isBgWhite} {...rest}>
              <Label color={item.subLabel ? '#000' : '#707070'}>
                {item.label}
              </Label>
              {item.subLabel && (
                <div style={{ fontWeight: 500, fontSize: 12, color: '#000', marginTop: 2 }}>
                  {item.subLabel}
                </div>
              )}
            </StyledRadio>
          </RadioWrapper>
        ))}
      </StyledGrid>
    </RadioGroup>
    {error && (
      <span style={{ color: 'red', fontSize: '12px', marginTop: 4 }}>{error}</span>
    )}
  </Wrapper>
);

export default RadioGroupField;